import { render, staticRenderFns } from "./XeroAccountSettingsForm.vue?vue&type=template&id=fb072278&scoped=true&"
import script from "./XeroAccountSettingsForm.vue?vue&type=script&lang=js&"
export * from "./XeroAccountSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./XeroAccountSettingsForm.vue?vue&type=style&index=0&id=fb072278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb072278",
  null
  
)

export default component.exports